import logo from "@/assets/brand/fons/logo-color-hz.svg";
import mark from "@/assets/brand/fons/mark.svg";
import openGraph from "@/assets/brand/fons/open-graph.png";
import { AppEnvironment } from "..";
import { Brand } from "./types";

export const fonsBrand: Brand = {
  id: "fons",
  name: "Fons",
  shortName: "Fons",
  legalName: "Fons, Inc.",
  logos: {
    logo: {
      dark: logo,
      light: logo,
    },
    mark: {
      dark: mark,
      light: mark,
    },
    openGraph,
  },
  helpUrl: "https://help.fons.app",
  supportEmail: "hello@fons.com",

  pageTitle: (title: string) => `Fons | ${title}`,

  urls: (environment: AppEnvironment) => {
    switch (environment) {
      case "development":
        return {
          app: "https://local.fons.app",
          // api: "https://api-local.fons.app:3002",
          api: "https://api-next.fons.app",
          cdn: "https://cdn-next.fons.app",
          reports: "https://api-next.fons.app",
          web: "https://next.fons.com",
        };
      case "preview":
        return {
          app: "https://next.fons.app",
          api: "https://api-next.fons.app",
          cdn: "https://cdn-next.fons.app",
          reports: "https://reports-next.fons.app",
          web: "https://next.fons.com",
        };
      case "production":
        return {
          app: "https://fons.app",
          api: "https://api.fons.app",
          cdn: "https://cdn.fons.app",
          reports: "https://reports.fons.app",
          web: "https://fons.com",
        };
    }
  },
};
